import axiosBasicInstance from '../axiosConfig';

// const getAccountInfo = async (username, langId) => {
//    try {
//       const response = await axiosBasicInstance.get(`/management/account/${username}`);

//       return response;
//    } catch (error) {
//       throw error;
//    }
// };

const getAccountInfo = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/account-email`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

const getAccountByIdentity = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/account-by-identity`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateAccount = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/update-account`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

// const getCompanies = async (email) => {
//    try {
//       const response = await axiosBasicInstance.get(`/management/companies/${email}`);
//       return response;
//    } catch (error) {
//       throw error;
//    }
// };

// const getAccountList = async () => {
//    try {
//       const response = await axiosBasicInstance.get(`/management/account-list`);
//       return response;
//    } catch (error) {
//       throw error;

//    }
// };

const getAccountList = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/account-list`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const fetchAccount = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/fetch-account', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const infoGetByPPersonalID = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/info-get-personalid', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const checkMailInCompany = async (email, langId) => {
   try {
      const response = await axiosBasicInstance.get(`/management/email-check/${langId}/${email}`);
      return response;
   } catch (error) {
      throw error;
   }
};

const checkValid = async (citizenNumber, email, langId) => {
   try {
      const response = await axiosBasicInstance.get('/management/invitations/check-valid', { headers: { citizenNumber, email, langId }});
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteInvitations = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/invitations/delete-invitations', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateKeyCloak = async (userId, data) => {
   try {
      const response = await axiosBasicInstance.post(`/update-keycloak/${userId}`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const activeAccount = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/active-account', data);
      return response;
   } catch (error) {
      throw error;
   }
};


export { getAccountInfo, getAccountByIdentity, fetchAccount, infoGetByPPersonalID, getAccountList, updateAccount, checkMailInCompany, checkValid, deleteInvitations, updateKeyCloak, activeAccount};
